import $ from 'jquery';
import { find } from 'lodash';
import ngAnnotate from './ngAnnotate.macro';
import viewTemplate from './listing/view/listing_view.html';
import appointmentListTemplate from './directive/appointmentList.html';
import appointmentActionTabsTemplate from './listing/appointments/appointment_action_tabs.html';
import listingContactsTemplate from './listing/contacts/listing_contacts.html';
import { lazyInjector } from './lazyInjector';

function run(
  $rootScope,
  $templateCache,
  $http,
  $location,
  $route,
  $routeParams,
  $window,
  $injector,
) {
  // Store injector for angular2react
  lazyInjector.$injector = $injector;

  $templateCache.put('/app/listing/view/view.html', viewTemplate);
  $templateCache.put('/appointmentList.html', appointmentListTemplate);
  $templateCache.put(
    '/appointment_action_tabs.html',
    appointmentActionTabsTemplate,
  );
  $templateCache.put('/listing_contacts.html', listingContactsTemplate);

  $rootScope.auth = {};
  $rootScope._ = $window._;
  $rootScope.toggleMenu = () => {
    if ($(window).width() < 769) {
      $('body').toggleClass('show-sidebar');
    }
  };

  // Viewing functions
  // this function should be removed from the rootscope
  // be sure to remove it from the Appointment watch controller as well.
  $rootScope.viewDashAppointment = (appointment, search) => {
    $rootScope.$evalAsync(() => {
      // Attempted gets set to isPending: true for multi-conf
      const actionRequiredStatuses = [
        'new',
        'time_change',
        'attempted',
        'time_passed',
      ];
      let status = 'action';
      if (
        appointment.isPending &&
        !actionRequiredStatuses.includes(appointment.status)
      ) {
        ({ status } = appointment);
      }

      const criteria = search || {};

      $location
        .path(`appointments/${appointment.id}/${status}`)
        .search(criteria);
    });
  };

  $rootScope.viewNextAppointmentPage = (
    appointmentId,
    isPending,
    action,
    listingId,
  ) => {
    let path;

    const { sids } = $routeParams;
    if (isPending) {
      path = `/appointments/${appointmentId}/${action}`;
    } else {
      if (sids) {
        // remove the appointment from sids
        const index = sids.indexOf(appointmentId);
        if (index > -1) {
          sids.splice(index, 1);
        }
      }

      if (sids && sids.length > 0) {
        const appointment = find($rootScope.appointmentsToService, {
          id: sids[0],
        });
        $rootScope.viewDashAppointment(appointment, { sids });
      } else if ($rootScope.auth.role === 'AGENT' && listingId) {
        path = `/listing/${listingId}/view`;
      } else if ($rootScope.auth.org.type === 'brokerage') {
        path = '/admin/dashboard';
      } else {
        path = '/answering/queue';
      }
    }

    if (path === $location.path()) {
      $route.reload();
    } else {
      $location.path(path).search({ sids });
    }
  };
}

ngAnnotate(run);

export default run;
